import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@fi-app/components/components.module';
import { BillingCentralListComponent } from './billing-central-list/billing-central-list.component';
import { BillingCentralViewComponent } from './billing-central-view/billing-central-view.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { BillingCentralEditComponent } from './billing-central-edit/billing-central-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatCardModule } from '@angular/material/card';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        MatRadioModule,
        SelectSearchModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatCardModule,
        FiToggleSwitchModule,
    ],
    declarations: [BillingCentralListComponent, BillingCentralViewComponent, BillingCentralEditComponent],
})
export class BillingCentralModule {}
